import { Button, Menu, MenuItem, Typography, alpha } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";

export default function NavigationItem({ page, navigate, location, theme }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const isActive =
    location.pathname === page.path ||
    page.children?.some((x) => x.path === location.pathname);

  if (!page.children) {
    return (
      <Button
        startIcon={page.icon}
        onClick={() => navigate(page.path)}
        disableRipple
        sx={{
          color: isActive ? "primary.main" : "text.secondary",
          fontWeight: isActive ? 600 : 500,
          textTransform: "none",
          fontSize: "0.9rem",
          px: 2,
          py: 0.8,
          backgroundColor: isActive
            ? alpha(theme.palette.primary.main, 0.08)
            : "transparent",
        }}
      >
        {page.title}
      </Button>
    );
  }

  return (
    <>
      <Button
        startIcon={page.icon}
        endIcon={<ExpandMoreIcon />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        disableRipple
        sx={{
          textTransform: "none",
          fontWeight: 500,
        }}
      >
        {page.title}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {page.children.map((child) => (
          <MenuItem
            key={child.title}
            onClick={() => {
              navigate(child.path);
              setAnchorEl(null);
            }}
          >
            {child.icon}

            <Typography ml={1}>{child.title}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
